import { Link, NavLink, useLocation } from "react-router-dom";
// import { } from "react-router-dom";

function Header() {
  var location = useLocation();
  console.log(location);
  return (
    <>
      {/* <div className="text-white text-center" style={{ background: "#001944" }} id="scroll_top">
        This is the message from XGlobal
      </div> */}
      {/* <header className="theme-main-menu sticky-menu  theme-menu-two sm-mt-5 mt-md-3 mt-lg-0"> */}
      <header className="theme-main-menu sticky-menu  theme-menu-two  mt-lg-0">
        <div className="inner-content">
          <div className="container d-flex align-items-center justify-content-between">
            <div className="logo order-lg-0">
              {" "}
              <a href="/" className="d-block">
                <img src="images/logo/x_global_blue.svg" alt="" width={250} />
              </a>
            </div>
            <a
              href="https://front.xglobal.live/"
              className="get-in-touch-btn d-none d-lg-block order-lg-3 px-3  rounded-pill"
            >
              {" "}
              #TapwithXGlobal
            </a>

            <nav className="navbar navbar-expand-lg order-lg-2">
              <button
                className="navbar-toggler d-block d-lg-none"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span />
              </button>
              <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav">
                  <li className="d-block d-lg-none">
                    <div className="logo">
                      <a href="/">
                        <img
                          src="images/logo/x_global_blue.svg"
                          alt=""
                          width={130}
                        />
                      </a>
                    </div>
                  </li>
                  <li
                    className={
                      location.pathname === "/about"
                        ? "nav-item active"
                        : "nav-item"
                    }
                  >
                    <Link className="nav-link" to="/about">
                      {" "}
                      About Us
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/research"
                        ? "nav-item active"
                        : "nav-item"
                    }
                  >
                    <Link className="nav-link" to="/research">
                      {" "}
                      Research
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="#"
                      role="button"
                    >
                      Developer
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/ecosystem"
                        ? "nav-item active"
                        : "nav-item"
                    }
                  >
                    <Link className="nav-link" to="/ecosystem">
                      Ecosystem
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/ignite_studio"
                        ? "nav-item active"
                        : "nav-item"
                    }
                  >
                    <Link to="#" className="nav-link">XGlobal Studio</Link>
                  </li>
                </ul>
                {/* Mobile Content */}
                <div className="mobile-content d-block d-lg-none">
                  <div className="d-flex flex-column align-items-center justify-content-center mt-70">
                    <Link
                      target="_blank"
                      to="https://t.me/Xglobbal_Bot/"
                      className="get-in-touch-btn rounded-pill"
                    >
                      #TapwithXGlobal
                    </Link>
                  </div>
                </div>{" "}
                {/* /.mobile-content */}
              </div>
            </nav>
          </div>
        </div>{" "}
        {/* /.inner-content */}
      </header>

    </>
  );
}

export default Header;
